import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';

import Deed from 'entities/deed/model';
import User from 'entities/user/model';
import DialogButton from 'retired/DialogButton';

import { setOptInStatusAction } from './actions';
import { selectOptInStatusLoading } from './selectors';

interface Props {
  optedIn: boolean;
  deed: Deed;
  user: User;
}

export const OptInButton = ({ optedIn, deed, user }: Props) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectOptInStatusLoading);
  return (
    deed && (
      <DialogButton
        buttonProps={{
          color: 'primary',
          variant: 'contained',
        }}
        style={{
          display: 'inline-block',
          padding: 20,
        }}
        buttonLabel={
          loading ? (
            <CircularProgress style={{ color: 'white', fill: 'white' }} size="20px" />
          ) : optedIn ? (
            'Remove'
          ) : (
            'Add'
          )
        }
        title={
          optedIn
            ? 'Remove this opportunity from your organization'
            : 'Add this opportunity to your organization'
        }
        text={
          optedIn
            ? 'Are you sure you want to remove this opportunity from your organization? It will no longer be visible to your employees.'
            : 'Are you sure you want to add this opportunity to your organization? It will become visible to all your employees.'
        }
        confirmLabel={optedIn ? 'Remove' : 'Add'}
        cancelLabel="Go Back"
        handleConfirm={() => dispatch(setOptInStatusAction(deed, user, !optedIn))}
      />
    )
  );
};
